import { templatePreview } from "./templatePreviewReducer";

export const template_preview_action = (query) => async (dispatch) => {
    try {
        dispatch(templatePreview(query));
    } catch (err) {
        const error = {
            code: 0,
            message: typeof err == 'object' ? err.message : err,
        };
        throw error;
    }
};
